// @ts-check
import { getAttributionQuery, getPriceString } from './commonUtils';

/**
 * @typedef {Object} SharedLookData
 * @property {string} associateId
 * @property {array} recipients
 * @property {string} userBrand
 * @property {string} brand
 * @property {array} children
 * @property {string} trackingValue
 * @property {Object} signatureData
 * @property {Object} toggles
 * @property {string} [isCollectionStyleboardEnabled]
 * @property {string} [isEditsStyleboardPaddingEnabled]
 * @property {string} [isBgClickThroughEnabled]
 */

/**
 * @typedef {Object} PreparedLookData
 * @property {SharedLookData} data
 * @property {array} children
 * @property {string} recipient
 */

/**
 *
 * @param {SharedLookData} sharedData
 * @returns PreparedLookData
 */
// eslint-disable-next-line import/prefer-default-export
export const prepareLandingPage = (sharedData) => {
  const { associateId, recipients, userBrand, toggles } = sharedData;

  /** @type SharedLookData */
  const data = { ...sharedData, ...toggles };
  data.brand = userBrand;

  const mappedChildren = sharedData.children.map((child) => ({
    ...child,
    productUrl: child.productUrl + getAttributionQuery(associateId, userBrand),
    price: getPriceString(child.retailPrice),
    nmgPimId: child.nmgPimId?.toString(),
  }));

  return {
    ...data,
    recipient: recipients.length > 1 ? null : recipients[0]?.displayName,
    children: mappedChildren,
  };
};
